import React from "react";
import styled, { css, useTheme } from "styled-components";
import PropTypes from "prop-types";
import Button from "components/Button";
import Link from "next/link";
import RichTextField from "components/Contentful/RichTextField";
import {
  setThemeColor,
  setContrastingThemeColor,
} from "lib/theme-color-helpers";
import useCustomerUser from "hooks/use-customer-user";
import LogoutButtonLink from "components/ActionItem/LogoutButtonLink";
import { LinkWrapper } from "components/Shared";

const OuterWrapper = styled.section`
  align-items: center;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.themeColors.primary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4rem 2.5rem;
  text-align: center;
  width: 100%;

  ${({ fontColor }) =>
    fontColor &&
    css`
      color: ${fontColor};
    `}
`;

const RichTextWrapper = styled.div`
  width: 100%;
  margin: 0 auto 1.5rem;

  ${({ theme }) => theme.mq.md`
    max-width: 38.75rem;
  `}

  ${({ theme }) => theme.mq.md`
    max-width: 47.5rem;
  `}
`;

const ButtonWrapper = styled.a`
  display: flex;
  margin: 0 auto;
  width: 100%;

  ${({ theme }) => theme.mq.md`
    margin: 0 auto;
    max-width: 18.0625rem;
  `}
`;

function CtaBasicBlock({ blockData }) {
  const theme = useTheme();
  const backgroundColor = blockData?.backgroundColor;
  const outerWrapperBackgroundColor =
    theme.themeColors[setThemeColor(backgroundColor)];
  const fontColor = setContrastingThemeColor(backgroundColor);
  const buttonTextColor = setThemeColor(backgroundColor);
  const copy = blockData?.copy;
  const buttonLink = blockData?.buttonLink;
  const buttonText = blockData?.buttonText;
  const customerUser = useCustomerUser();
  const providerSignUpLink = "/provider/auth/sessionless";

  return (
    <OuterWrapper backgroundColor={outerWrapperBackgroundColor}>
      <RichTextWrapper>
        <RichTextField
          richText={copy}
          textAlignment="center"
          textColor={fontColor}
        />
      </RichTextWrapper>
      {buttonLink !== providerSignUpLink && (
        <Link href={buttonLink} passHref>
          <ButtonWrapper>
            <Button colorType={fontColor} textColor={buttonTextColor}>
              {buttonText}
            </Button>
          </ButtonWrapper>
        </Link>
      )}
      {buttonLink === providerSignUpLink && !customerUser ? (
        <Link href={buttonLink} passHref>
          <ButtonWrapper>
            <Button colorType={fontColor} textColor={buttonTextColor}>
              {buttonText}
            </Button>
          </ButtonWrapper>
        </Link>
      ) : (
        <LinkWrapper>
          <LogoutButtonLink
            bgColor={theme.themeColors.blue1}
            color={theme.themeColors.darkGreen1}
            fontSize="16px"
            textContent={buttonText}
            redirectUrl={buttonLink}
            isButton
          />
        </LinkWrapper>
      )}
    </OuterWrapper>
  );
}

export default CtaBasicBlock;

CtaBasicBlock.propTypes = {
  blockData: PropTypes.shape({
    backgroundColor: PropTypes.string,
    copy: PropTypes.shape({}),
    buttonLink: PropTypes.string,
    buttonText: PropTypes.string,
  }),
};

CtaBasicBlock.defaultProps = {
  blockData: {
    backgroundColor: "",
    copy: {},
    buttonText: "Join GoodFriend",
    buttonLink: undefined,
  },
};
